
import Vue from 'vue'
import axios from 'axios'
import ProductDialog from '@/components/ProductDialog.vue'
import IProductDecription from '@/types/ProductDecription'
import { ProductLinkRegistry } from '@/types/ProductLinkRegistry'

export default Vue.extend({
  components: {
    ProductDialog
  },

  data: () => ({
    fetching: false as boolean,
    prodDesc: null as IProductDecription | null,
    selectedImage: '',
    showImageDialog: false
  }),

  computed: {
    quote () { return this.$store.state.quote }
  },

  methods: {
    send () {
      this.fetching = true

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?send', this.$store.getters.getAllDataAsJson)
        .then(() => {
          alert('Árajánlat igénylés küldése sikeres. Köszönjük érdeklődését, értékesítő kollégánk hamarosan felveszi Önnel a kapcsolatot! Kezdje újra az árajánlat igénylését egy másik termék kiválasztásával.')
          this.$emit('reset')
          this.$emit('resetdatapolicy')
          this.$store.commit('resetAll')
        })
        .catch(error => console.log(error))
        .finally(() => { this.fetching = false })
    },
    getProductImg (name: string): string {
      return ProductLinkRegistry.getImg(name)
    },
    getProductDesc (name: string): IProductDecription | null {
      return ProductLinkRegistry.getProductDescription(name)
    },
    HasImageOrProductDescription (imageUrl: string, prodDesc: IProductDecription | null): boolean {
      return !!(prodDesc || (imageUrl && imageUrl !== ''))
    },
    openImageDialog (imageUrl: string, prodDesc: IProductDecription | null) {
      this.prodDesc = prodDesc || null
      this.selectedImage = imageUrl
      this.showImageDialog = this.HasImageOrProductDescription(imageUrl, prodDesc)
    }
  }
})
